

































































import Vue from 'vue'

import { QAQC, GetQAQC, QAQCParameter, PatchQAQC } from '@/api/cems'

export default Vue.extend({
  data() {
    return {
      qaqcId: 0,
      qaqc: { parameters: [] as QAQCParameter[] } as QAQC,
      parameters: [] as QAQCParameter[],
      deletedPatameters: [] as number[],
    }
  },

  methods: {
    async getQAQC() {
      this.qaqc = await GetQAQC(this.qaqcId)
      this.cloneParameter()
    },

    async patchQAQC() {
      await PatchQAQC(this.qaqcId, this.qaqc, this.deletedPatameters)
      await this.getQAQC()
    },

    // ------------------------------------------------------------------------------
    // Keyboard & mouse Events
    // ------------------------------------------------------------------------------
    onRowClick(qaqc: QAQC) {
      this.$router.push({
        path: `/cems/setting/qaqc/${qaqc.id}`,
      })
    },

    addParameter() {
      const newParameter = { id: 0, name: '' } as QAQCParameter
      this.qaqc.parameters.push(newParameter)
    },

    cloneParameter() {
      this.parameters = JSON.parse(JSON.stringify(this.qaqc.parameters))
    },

    deleteParameter(index: number) {
      const par = this.qaqc.parameters[index]
      if (par.id != 0) {
        this.deletedPatameters.push(par.id)
      }
      this.qaqc.parameters.splice(index, 1)
    },

    resetParameter() {
      this.deletedPatameters = []
      this.qaqc.parameters = JSON.parse(JSON.stringify(this.parameters))
    },

    onFormSubmit(ev: Event) {
      ev.preventDefault()
      this.patchQAQC()
    },

    onFormReset(ev: Event) {
      ev.preventDefault()
      this.$router.push('/cems/setting/qaqc')
    },
  },

  async created() {
    this.qaqcId = parseInt(this.$route.params.qaqcId)
    await this.getQAQC()
  },
})
